<template>
    <div class="col-md-4 right-panel clearfix pt-3" v-if="newsList[1]">
        <h3>{{ $t('news.NextNews') }}</h3>
        <Counter/>
        <hr>
        <div class="panel-item row" v-for="item in newsList[1].data" :key="item.slug">
            <div class="col-12 col-md-6 col-lg-4" v-if="!hideImage">
                <router-link :to="getNewsUri(item)">
                    <img v-lazy="item.image" class="img-thumbnail">
                </router-link>
            </div>
            <div :class="hideImage ? 'col-12' : 'col-12 col-md-6 col-lg-8'">
                <h4>
                    <router-link :to="getNewsUri(item)">{{item.title}}</router-link>
                </h4>
                <small>{{ item.updated_at | formatTime }}</small>
            </div>
        </div>
    </div>
</template>

<script>
  import { NEWS_TYPES } from '../../constants';
  import Counter from '../../components/counter/Counter';

  export default {
    name: 'SidePanelNews',
    components: { Counter },
    props: ['listType', 'hideImage'],
    methods: {
      getNewsUri(news) {
        return `/news/${news.slug}`;
      },
    },
    computed: {
      newsList() {
          return this.$store.state.news.list[this.listType || NEWS_TYPES.LATEST];
      }
    }
  };
</script>

<style scoped>

</style>
